import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Typography,
  Box,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  Card,
  CardHeader,
  ListItem,
  CardActions,
  ListItemAvatar,
  Avatar,
} from "@mui/material";

import { connect } from "react-redux";
import NoRecordMessage from "../../common/components/NoRecordMessage";

import { setQuestionType } from "../../../store/recruitment/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import ReactPaginate from "react-paginate";

const QuestionTypes = (props) => {
  const { loading, user, questionTypes, setQuestionType } = props;

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  useEffect(() => {
    paginate(questionTypes);
  }, [itemOffset, itemsPerPage, questionTypes]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % questionTypes.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  return (
    <Card className="border elevated-1 hoverable-card" variant="outlined">
      <div
        className="mb-3"
        style={{
          height: "55vh",
          overflow: "auto",
        }}
      >
        <List
          dense
          component="div"
          subheader={
            <ListSubheader
              className=" border-bottom  font-weight-bold"
              component="div"
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                // backgroundColor: "#e6ebf1",
              }}
            >
              Question types
            </ListSubheader>
          }
        >
          {paginatedItems
            ?.filter(({ id }) => id !== 2)
            ?.map((questionType, index) => (
              <QuestionTypeCard
                index={getNo(
                  paginatedItems?.filter(({ id }) => id !== 2),
                  "id",
                  questionType.id
                )}
                key={questionType.id}
                loading={loading}
                user={user}
                questionType={questionType}
                setQuestionType={setQuestionType}
              />
            ))}
        </List>
        <NoRecordMessage
          isEmpty={!paginatedItems?.length}
          title="No record found. "
        />
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel={
          <>
            {/* <span className="pr-1 d-none d-md-inline">Next</span> */}
            <i className="fas fa-angle-double-right"></i>
          </>
        }
        previousLabel={
          <>
            <i className="fas fa-angle-double-left"></i>
            {/* <span className="pl-1  d-none d-md-inline">Previous</span> */}
          </>
        }
        pageRangeDisplayed={2}
        marginPagesDisplayed={1}
        onPageChange={handlePageClick}
        pageCount={pageCount}
        renderOnZeroPageCount={null}
        containerClassName="pagination"
        pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
        previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
        nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
        activeLinkClassName="active"
      />
    </Card>
  );
};

const mapStateToProps = ({ user, loading, questionTypes }) => {
  return {
    user,
    loading,
    questionTypes,
  };
};

export default connect(mapStateToProps, { setQuestionType })(QuestionTypes);

const QuestionTypeCard = (props) => {
  const { loading, user, questionType, index, setQuestionType } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showConfirmDisable, setShowConfirmDisable] = useState(false);

  return (
    <>
      <ListItem
        divider
        key={questionType.id}
        secondaryAction={
          <span>
            <IconButton
              size="small"
              onClick={handleOpenMenu}
              aria-label="settings"
            >
              <span className="material-icons">more_vert</span>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleCloseMenu}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 2,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 15,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();
                    setShowConfirmDisable(true);
                  }}
                  className={`text-${
                    !questionType.isActive ? "success" : "danger"
                  } font-weight-light`}
                >
                  {questionType.isActive && (
                    <span className="material-icons mr-2">close</span>
                  )}
                  {!questionType.isActive && (
                    <span className="material-icons mr-2">check</span>
                  )}
                  {questionType.isActive ? "Disable" : "Enable"}
                </MenuItem>
              </span>
            </Menu>
          </span>
        }
      >
        <ListItemAvatar>
          <Avatar variant="square">{index + 1}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={<span>{questionType.name}</span>}
          secondary={
            <span
              className={`d-inline-flex align-items-center text-${
                questionType.isActive ? "success" : "danger"
              }`}
            >
              <span
                style={{ fontSize: "12px" }}
                className={`material-icons text-${
                  questionType.isActive ? "success" : "danger"
                }`}
              >
                fiber_manual_record
              </span>
              {questionType.isActive ? "Active" : "Disabled"}
            </span>
          }
        />
      </ListItem>

      {showConfirmDisable && (
        <ConfirmationDialog
          confirmationDialog={showConfirmDisable}
          message={
            <>
              Are you sure you want to{" "}
              <strong
                className={`text-${
                  questionType.isActive ? "danger" : "success"
                }`}
              >
                {questionType.isActive ? "disable" : "enable"}
              </strong>{" "}
              this quesition type?
            </>
          }
          setConfirmationDialog={setShowConfirmDisable}
          noPreFormat={true}
          onYes={() => {
            setQuestionType(
              { id: questionType.id, isActive: !questionType.isActive },
              () => setShowConfirmDisable(false)
            );
          }}
        />
      )}
    </>
  );
};
